import { Button, Stack, Text } from '@chakra-ui/react';

interface TodoCardMessageProps {
  message: string;
  retryLabel?: string;
  onRetry?: () => void;
}

/** The card's body when it has no line to list: all clear, or nothing could be read. */
export const TodoCardMessage = ({ message, retryLabel, onRetry }: TodoCardMessageProps) => (
  <Stack
    align="center"
    gap="10px"
    px="12px"
    py="20px"
    borderTopWidth="1px"
    borderTopColor="border.subtle"
  >
    <Text fontSize="14px" color="inkMuted" textAlign="center">
      {message}
    </Text>
    {onRetry && retryLabel && (
      <Button size="xs" variant="outline" onClick={onRetry}>
        {retryLabel}
      </Button>
    )}
  </Stack>
);
